/**
 * Default values for user-created data, shared by everything that creates or
 * falls back to one.
 *
 * These are data defaults, not style decisions — the tag and list colour and
 * emoji *palettes* stay with the pickers that render them (see the exemption in
 * CLAUDE.md), because those are the choices offered to the user rather than the
 * value the app picks on their behalf.
 */

/**
 * The emoji a list gets when the user hasn't chosen one, and the stand-in shown
 * wherever a task's list emoji is missing (no list, a list that was deleted, or
 * a list whose emoji was cleared).
 */
export const DEFAULT_LIST_EMOJI = "📁";

/**
 * A blank emoji is the same as no choice. Callers that save a list, and callers
 * that paint one, both use this so a cleared field is stored as the folder and
 * an older blank row still paints as that same folder.
 */
export function listEmojiOrDefault(emoji: string | null | undefined): string {
  const trimmed = emoji?.trim() ?? "";
  return trimmed.length > 0 ? trimmed : DEFAULT_LIST_EMOJI;
}

/** The colour a new tag is created with unless the user picks another. */
export const DEFAULT_TAG_COLOR = "#6366f1";
